export function isTrustedApiRequestUrl(requestUrl: string, apiUrl: string, browserBaseUrl: string): boolean {
	if (/[\u0000-\u001f\u007f\\]/.test(requestUrl) || requestUrl.trimStart().startsWith('//')) {
		return false;
	}

	try {
		const apiBaseUrl = new URL(apiUrl, browserBaseUrl);
		const url = new URL(requestUrl, browserBaseUrl);
		const apiPath = apiBaseUrl.pathname.replace(/\/$/, '');
		const matchesApiPath = !apiPath || url.pathname === apiPath || url.pathname.startsWith(`${apiPath}/`);

		return url.origin === apiBaseUrl.origin && matchesApiPath;
	} catch {
		return false;
	}
}
